const REPORTES = {
    PIVOT_CASOS: {
      INFO: [],
      PIVOTS: [],
    },
    PIVOT_COMENTARIOS_CASOS: {
      INFO: [],
      PIVOTS: [],
    },
    PIVOT_COMENTARIOS_USUARIOS: {
      INFO: [],
      PIVOTS: [],
    },
    DESCARGAS_EXCEL: [],
  };
  
  export default REPORTES;
  